export const LOADER_PAISES         =       'LOADER_PAISES';
export const GET_PAISES            =       'GET_PAISES';
export const PAISES_FALLA          =       'PAISES_FALLA';
export const SAVE_LOADER_PAISES    =       'SAVE_LOADER_PAISES';
export const FORM_PAISES_FAIL      =       'FORM_PAISES_FAIL';

